import { useStackStyles } from './Stack.styles';
import { jsx as _jsx } from "react/jsx-runtime";
const Stack = ({
  gap,
  padding,
  align,
  justify,
  grow,
  overflow,
  maxWidth,
  maxHeight,
  border,
  children
}) => {
  const style = useStackStyles({
    gap,
    padding,
    align,
    justify,
    grow,
    overflow,
    maxWidth,
    maxHeight,
    border
  });
  return /*#__PURE__*/_jsx("div", {
    style: style,
    children: children
  });
};
export default Stack;